/**
 * Registry of non-essential Rovo Chat localStorage keys.
 *
 * Add new non-essential keys here to allow them to be selectively disabled
 * via the Statsig dynamic config `rovo_chat_disabled_non_essential_ls_keys`
 * during an incident — without requiring a code deploy.
 *
 * A key is "non-essential" if Rovo Chat can function correctly without it
 * (e.g. a UI preference or optimisation). Wrap all accesses to these keys
 * with `withNonEssentialLocalStorage`.
 */
export const LS_CHAT_LOAD_PREFERENCE_KEY = 'aiMateChatLoadPreference';
export const LS_USER_PREFERENCES_KEY = 'aiMateUserPreferences';

export const NON_ESSENTIAL_LOCAL_STORAGE_KEYS: readonly [
	typeof LS_CHAT_LOAD_PREFERENCE_KEY,
	typeof LS_USER_PREFERENCES_KEY,
] = [LS_CHAT_LOAD_PREFERENCE_KEY, LS_USER_PREFERENCES_KEY];
